export const UserDefaultConfigConstants = {
    WEEK_HOLIDAYS: {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: true,
        7: true,
    },

    /** Переносы заявки: 1–365 дней; 0 = без лимита. */
    APPLICATION_MAX_DELAY_DAYS: 0,

    /** 1001=не удалять, 1002=1д, 1003=1нед, 1004=2нед, 1005=1мес. */
    NOTIFICATION_DELETE_AFTER_VALUE: '1001',

    /** Интервал сетки календаря, минуты. */
    CALENDAR_SLOT_DURATION: 30,

    CALENDAR_SLOT_MIN_TIME: '09:00',

    CALENDAR_SLOT_MAX_TIME: '18:00',

    ATON_LOGIN: undefined,
    ATON_PASS: undefined,
    ATON_GROUP: undefined,
    ATON_PATH_TO_2FA: undefined,
    ATON_SHOW_VALUATION: undefined,

    HIERARCHY_NODE_POSITIONS: {} as Record<number, { x: number; y: number }>,
}
